import { Badge, Box, Group, Text, useMantineColorScheme } from "@mantine/core";
import { IconCheck, IconLoader2, IconX } from "@tabler/icons-react";

interface ToolActivity {
    internalName: string;
    done: boolean;
    error?: boolean;
}

export const ReadingIndicator = ({ toolActivities = [] }: { toolActivities?: ToolActivity[] }) => {
    const { colorScheme } = useMantineColorScheme();
    const isDark = colorScheme === "dark";
    const dotColor = isDark ? "#5c5f66" : "#868e96";

    return (
        <Group gap="xs" align="center" py={4}>
            {/* 3 bouncing dots */}
            <Group gap={3} align="center">
                {[0, 1, 2].map((i) => (
                    <Box
                        key={i}
                        style={{
                            width: 5,
                            height: 5,
                            borderRadius: "50%",
                            backgroundColor: dotColor,
                            animation: `ri-bounce 1.2s ease-in-out ${i * 0.2}s infinite`,
                        }}
                    />
                ))}
            </Group>

            <Text size="sm" fw={500} c="dimmed">
                Searching our knowledge bases for an answer
            </Text>

            {toolActivities.map((activity, i) => {
                const key = `${activity.internalName}-${i}`;
                const label = activity.internalName.replace(/_/g, " ");
                if (!activity.done) {
                    return (
                        <Badge
                            key={key}
                            variant="light"
                            color="violet"
                            style={{ textTransform: "none" }}
                            leftSection={
                                <IconLoader2
                                    size={12}
                                    style={{ animation: "ri-spin 1s linear infinite" }}
                                />
                            }
                        >
                            {label}
                        </Badge>
                    );
                }
                if (activity.error) {
                    return (
                        <Badge
                            key={key}
                            variant="light"
                            color="red"
                            style={{ textTransform: "none" }}
                            leftSection={<IconX size={12} />}
                        >
                            {label}
                        </Badge>
                    );
                }
                return (
                    <Badge
                        key={key}
                        variant="light"
                        color="gray"
                        style={{ textTransform: "none" }}
                        leftSection={<IconCheck size={12} />}
                    >
                        {label}
                    </Badge>
                );
            })}

            <style>{`
                @keyframes ri-bounce {
                    0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
                    40% { transform: translateY(-5px); opacity: 1; }
                }
                @keyframes ri-spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </Group>
    );
};
